import defined from './defined';

/**
 * Tests whether or not a value is undefined or null. Identical to (typeof value === 'undefined' || value === null).
 * @param value - The value to evaluate.
 */
export default function empty(value: unknown): value is undefined | null {
    return !defined(value) || value === null;
}
